module.exports = __webpack_public_path__ + "img/1123565208.d36e0745.png";